export const navItems = [
  {
      name: "Home",
      link: "/"
  },
  {
      name: "Services",
      link: "/services"
  },
  {
      name: "About Us",
      link: "/about-us"
  },
  {
      name: "Contact Us",
      link: "/contact-us"
  },
  {
        name: "Privacy Policy",
        link: "/privacy-policy"
  }
];


